<template>
    <div>

        <div v-if="!em_edicao">

            <div class="card dashcard mb-3">
            
                <div class="card-body">

                    <div class="form-row">
                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="fab fa-google fa-fw"
                                placeholder="Todos os Grupos..."
                                type="select"
                                service="estoque_grupos.index"
                                optionsData="id_estoque_grupo"
                                optionsMode="aql"
                                v-model="id_estoque_grupo" />
                        </div>
                        <div class="col col-12 col-md-6">
                            <az-input icon="fas fa-search" v-model="search">
                                <template v-slot:buttonposb>
                                    <importacao service="estoque_items" @refresh="load()" />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-secondary" @click="vincular_cobranca ()" title="Vincular Cobrança">
                                            <i class="fa-solid fa-link"></i>
                                        </button>
                                        <button type="button" class="btn btn-outline-primary" @click="incluir ()">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'A'">
                                    Ativos
                                </button>
                                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'T'">
                                    Todos
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum item de estoque identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Item'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0">
                            {{ dado.search }} 
                        </a>
                        <span class="badge badge-secondary mx-3">
                            #{{ dado.id_estoque_item }}
                        </span>
                        <a href="#" @click.prevent="search == '&quot;' + dado.grupo.search + '&quot;' ? search = '' : search = '&quot;' + dado.grupo.search + '&quot;'" class="card-link">
                            <small class="text-muted" v-if="dado.grupo">
                                {{ dado.grupo.search }}
                            </small>
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span v-if="dado.js_classes">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </span>
                            <button type="button" class="btn btn-outline-primary btn-sm ml-3" @click="ver_parms(dado)" title="Parâmetros do Estoque">
                                <i class="fas fa-tachometer-alt"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary btn-sm ml-2" @click="emitir_etiqueta(dado)" title="Impressão de Etiquetas">
                                <i class="fa fa-tags" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary btn-sm ml-2" @click="limite_de_estoque(dado)" title="Limite de Quantidade em Estoque">
                                <i class="fa-solid fa-less-than-equal"></i>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_estoque_item ? '' : 'Novo' }}
                            Item de Estoque 
                            <span class="badge badge-secondary ml-1" v-if="item && item.id_estoque_item">
                                #{{ item.id_estoque_item }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <az-empty-state v-if="item.carregando" />

                        <template v-else>

                            <div class="row">
                                <div class="col col-12 col-md-8">
                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                sizing="sm"
                                                label="Descrição"
                                                :validate="validate"
                                                required
                                                v-model="item.st_estoque_item" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                type="select"
                                                label="Grupo"
                                                service="estoque_grupos.index"
                                                optionsMode="aql"
                                                optionsDisplay="search"
                                                optionsData="id_estoque_grupo"
                                                :validate="validate"
                                                required
                                                v-model="item.id_estoque_grupo" />
                                        </div>

                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                label="Id Externo"
                                                v-model="item.st_id_externo" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-4 d-flex justify-content-end" v-if="item.id_estoque_item">
                                    <az-single-image-loader
                                        titulo="Imagem"
                                        chave="ass"
                                        :single="true"
                                        :arquivo="item.logo"
                                        :parms="{ model_type: 'estoqueItem', model_id: item.id_estoque_item }"
                                        service="estoque_items">
                                    </az-single-image-loader>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="NCM"
                                        v-model="item.st_ncm">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <a href="https://www.gov.br/receitafederal/pt-br/assuntos/aduana-e-comercio-exterior/classificacao-fiscal-de-mercadorias/ncm" class="btn btn-outline-secondary" type="button" id="button-addon2" target="_blank" rel="noopener noreferrer">
                                                    <i class="fa-solid fa-circle-question"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade de Medida (Armazenagem)"
                                        type="text"
                                        :validate="validate"
                                        required
                                        v-model="item.st_unidade_estoque" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade de Medida (Compra)"
                                        placeholder="Mesma de Armazenagem"
                                        type="text"
                                        :validate="validate"
                                        v-model="item.st_unidade_compra" />
                                </div>
                                <template v-if="item.st_unidade_estoque && item.st_unidade_compra && item.st_unidade_estoque != item.st_unidade_compra">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            label="Fator de Conversão"
                                            type="number"
                                            :validate="validate"
                                            required
                                            v-model="item.in_fator_conversao" />
                                    </div>
                                </template>
                            </div>

                            <div class="row my-2">
                                <template v-if="item.st_unidade_estoque && item.st_unidade_compra && item.st_unidade_estoque != item.st_unidade_compra">
                                    <div class="col col-12 col-md-4" v-if="isPowerOfTen(item.in_fator_conversao)">
                                        <az-input
                                            sizing="sm"
                                            label="Entrada Fracionada"
                                            type="checkbox-group"
                                            :validate="validate"
                                            v-model="item.fl_fracionado" />
                                    </div>
                                </template>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Controle de Lote/Validade"
                                        v-model="item.fl_controla_lote" />
                                </div>
                                
                            </div>

                            <div class="row my-2">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Kit de Montagem"
                                        v-model="item.fl_kit_transform" />
                                </div>
                                <div class="col col-12 col-md-4" v-if="item.fl_kit_transform">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Cobrança pelos Itens do Kit"
                                        v-model="item.fl_kit_tr_cobra_aberto" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <small class="text-muted">Classificação</small>
                                    <multiselect
                                        v-model="item.js_classes"
                                        :options="options_classes"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addTag"
                                        placeholder="Selecione uma classificação..."
                                        selectLabel="Pressione [ENTER] para selecionar"
                                        deselectLabel="Pressione [ENTER] para remover"
                                        tagPlaceholder="Pressione [ENTER] para incluir"
                                        selectedLabel="Selecionado">
                                        <template slot="noOptions">
                                            Nenhuma classificação criada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                            <template v-if="!item.fl_kit_transform || !item.fl_kit_tr_cobra_aberto">
                                
                                <div class="row" v-if="item.cobranca">
                                    <div class="col">
                                        <az-input
                                            id="cobrado"
                                            sizing="sm"
                                            label="Cobrança"
                                            :edicao="false"
                                            v-model="item.cobranca.search">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerCobranca()">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="item.cobranca">
                                                    <span class="input-group-text" id="basic-addon1">
                                                        #{{ item.cobranca.id_medicamento ? item.cobranca.id_medicamento : item.cobranca.id_material }}
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                <div class="row" v-else>
                                    <div class="col">
                                        <az-input
                                            id="cobranca"
                                            sizing="sm"
                                            icon="fa fa-plus fa-fw"
                                            label="Cobrança"
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            optionsName="consumo.estoque.index" 
                                            :optionsParm="{ estoque: true }"
                                            service="consumo.index"
                                            :optionsSync="true"
                                            v-model="novaCobranca"
                                            @input="definirCobranca ()" />
                                    </div>
                                </div>

                                <div v-if="item.cobranca && item.converts" class="mb-3">
                                    <az-sub-title title="Conversões de Unidade de Medida da Prescrição" class="mt-3">
                                        <a href="#" @click.prevent="incluir_convert(item)" class="card-link">
                                            <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                            Incluir
                                        </a>
                                    </az-sub-title>
                                    <div v-for="(convert, icx) in item.converts" :key="'CONV' + icx">
                                        <div class="form-row" v-if="!convert.excluido">
                                            <div class="col col-12 col-md-6">
                                                <az-input
                                                    placeholder="Apresentação..."
                                                    v-if="convert.apresentacao"
                                                    sizing="sm"
                                                    :edicao="false"
                                                    v-model="convert.apresentacao.search">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button type="button" class="btn btn-outline-danger" @click="convert.excluido = true">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>

                                                <az-input
                                                    placeholder="Apresentação..."
                                                    v-else
                                                    type="select"
                                                    sizing="sm"
                                                    service="apresentacoes.index"
                                                    optionsMode="aql"
                                                    optionsData="id_apresentacao"
                                                    v-model="convert.id_apresentacao">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button type="button" class="btn btn-outline-danger" @click="convert.excluido = true">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    placeholder="Ação..."
                                                    required
                                                    :validate="validate"
                                                    type="select"
                                                    :optionsList="[
                                                        { id: 'M', search: 'Multiplicar' },
                                                        { id: 'D', search: 'Dividir' },
                                                    ]"
                                                    optionsData="id"
                                                    v-model="convert.st_acao" />
                                            </div>
                                            <div class="col col-12 col-md-3" v-if="convert.st_acao">
                                                <az-input
                                                    :icon="convert.st_acao == 'D' ? 'fa-solid fa-divide' : 'fa-solid fa-xmark'"
                                                    sizing="sm"
                                                    placeholder="Fator..."
                                                    required
                                                    :validate="validate"
                                                    type="number"
                                                    v-model="convert.dc_fator" />
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="item.converts && !item.converts.length">
                                        Nenhuma conversão cadastrada.
                                    </div>
                                </div>

                            </template>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Observação"
                                        type="textarea"
                                        rows="3"
                                        :validate="validate"
                                        v-model="item.st_observacao" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Orientação de Compra"
                                        type="textarea"
                                        rows="3"
                                        :validate="validate"
                                        v-model="item.st_orientacao_compra" />
                                </div>
                            </div>

                            <div class="row" v-if="item.st_orientacao_compra">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Exibir Orientação de Compra para o Fornecedor"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.fl_orient_compra_fornec" />
                                </div>
                            </div>

                            <az-sub-title title="Código de Barras" class="mt-3" />
                            
                            <div class="row" v-for="(codigo, icx) in item.st_codigo_barra" :key="'CB' + icx">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Código de Barras..."
                                        required
                                        :validate="validate"
                                        v-model="item.st_codigo_barra[icx]">
                                        <template v-slot:button-pre>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_codigo_barra()">
                                                    <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <button class="btn btn-outline-primary btn-sm" type="button" id="button-addon2" @click="add_codigo_barra()">
                                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                            </button>

                            <!-- Componentes -->

                            <az-sub-title title="Componentes" class="mt-3">
                                <a href="#" @click.prevent="copiando = !copiando" class="card-link" v-if="!lista_componentes.length">
                                    {{ copiando ? 'Incluir' : 'Copiar de...' }}
                                </a>
                            </az-sub-title>

                            <div class="form-row" v-for="(comp, icx) in lista_componentes" :key="'COMP' + icx">
                                <div class="col col-12 col-md-8">
                                    <az-input
                                        :label="icx ? '' : 'Descrição'"
                                        sizing="sm"
                                        icon="fa fa-minus fa-fw"
                                        :buttonIcon="true"
                                        buttonColor="outline-danger"
                                        buttonText="fa fa-minus fa-fw"
                                        @clickButton="comp.excluido = true"
                                        :edicao="false"
                                        v-model="comp.item.search">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">#{{ comp.id_estoque_item }}</span>

                                                <button type="button" class="btn btn-outline-primary btn-sm"
                                                    v-if="comp.id_estoque_item_componente"
                                                    data-toggle="tooltip" data-placement="top" title="Unidades Habilitadas"
                                                    @click="unidade_operacao_lista(comp)">
                                                    <i class="fa-regular fa-building"></i>

                                                    <span class="badge badge-primary ml-1" title="Unidades Selecionados" v-if="comp.unidade_operacao_lista_count">
                                                        {{ comp.unidade_operacao_lista_count }}
                                                    </span>
                                                </button>

                                                <button type="button" class="btn btn-outline-primary btn-sm"
                                                    v-if="vias && vias.length"
                                                    data-toggle="tooltip" data-placement="top" title="Vias de Acesso"
                                                    @click="editar_vias(comp)">
                                                    <i class="fa-solid fa-syringe"></i>

                                                    <span class="badge badge-primary ml-1" title="Unidades Selecionados" v-if="comp.js_vias && comp.js_vias.length">
                                                        {{ comp.js_vias.length }}
                                                    </span>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        :label="icx ? '' : 'Quantidade'"
                                        sizing="sm"
                                        type="number"
                                        required
                                        :validate="validate"
                                        v-model="comp.in_quantidade">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <small>{{ comp.item.st_unidade_estoque }}</small>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        placeholder="Fixo..."
                                        :label="icx ? '' : 'Para Cada'"
                                        sizing="sm"
                                        type="number"
                                        :validate="validate"
                                        v-model="comp.in_para_cada">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <small>{{ item.st_unidade_estoque }}</small>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div v-if="copiando" class="alert alert-info">
                                Selecione o material de origem...
                            </div>

                            <selecao-material :blocklote="true" :kits="true" @selecionado="incluir_componente" />

                            <!-- Substitutos -->

                            <template v-if="item.id_estoque_item && item.subs">

                                <az-sub-title title="Substitutos" class="mt-3"></az-sub-title>

                                <div class="form-row" v-for="(sub, icx) in item.subs" :key="'COMPS' + icx">
                                    <div class="col col-12" v-if="!sub.excluido">
                                        <az-input
                                            sizing="sm"
                                            icon="fa fa-minus fa-fw"
                                            :buttonIcon="true"
                                            buttonColor="outline-danger"
                                            buttonText="fa fa-minus fa-fw"
                                            @clickButton="sub.excluido = true"
                                            :edicao="false"
                                            v-model="sub.por.search">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon2">#{{ sub.id_estoque_item_por }}</span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                <selecao-material :blocklote="true" @selecionado="incluir_substituto" />

                            </template>

                            <!-- Apresentações -- && ( item.st_unidade_estoque.toUpperCase() == 'MG' || item.st_unidade_estoque.toUpperCase() == 'ML' || item.apresentacoes.length ) -->

                            <template v-if="item.st_unidade_estoque">

                                <az-sub-title title="Apresentações" class="mt-3" />

                                <div v-for="(apresent, iax) in item.apresentacoes" :key="'APR' + iax">
                                    <div class="form-row" v-if="!apresent.excluido">
                                        <div class="col col-12 col-md-8">
                                            <az-input
                                                sizing="sm"
                                                icon="fa fa-minus fa-fw"
                                                :buttonIcon="true"
                                                buttonColor="outline-danger"
                                                buttonText="fa fa-minus fa-fw"
                                                @clickButton="apresent.excluido = true"
                                                :edicao="false"
                                                v-model="apresent.ampola.search">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">#{{ apresent.id_estoque_item_ampola }}</span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                placeholder="Quantidade..."
                                                sizing="sm"
                                                type="number"
                                                required
                                                :validate="validate"
                                                v-model="apresent.in_quantidade">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">{{ item.st_unidade_estoque }} por {{ apresent.ampola.st_unidade_estoque }}</span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>
                                </div>

                                <selecao-material :blocklote="true" @selecionado="incluir_apresentacao" />

                                <div v-if="item.apresentacoes && item.apresentacoes.filter(item => !item.excluido).length">

                                    <div class="form-row mt-3">
                                        <div class="col col-12 col-md-3">
                                            <az-input       
                                                sizing="sm"
                                                label="Estabilidade"
                                                type="number"
                                                placeholder="Estabilidade..."
                                                v-model="item.in_estabilidade" />
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input      
                                                sizing="sm" 
                                                label="Tempo"
                                                type="select"
                                                placeholder="Tempo..."
                                                v-if="item.in_estabilidade > 0"
                                                required
                                                :validate="validate"
                                                :optionsList="[
                                                    { value: 'days', search: 'Dia(s)' },
                                                    { value: 'hours', search: 'Hora(s)' }
                                                ]"
                                                optionsData="value"
                                                v-model="item.st_tempo_estabilidade" />
                                        </div>
                                    </div>

                                </div>

                            </template>

                            <!-- Local de Entrada das Compras -->

                            <az-sub-title title="Local de Armazenagem de Entrada das Compras" class="mt-3"></az-sub-title>
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Selecione (Opcional)..."
                                        type="select"
                                        service="estoque_locals.index"
                                        optionsData="id_estoque_local"
                                        optionsMode="aql"
                                        optionsName="estoque_locals.index.ativos"
                                        :optionsParm="{ ativos: true }"
                                        v-model="item.id_estoque_local" />
                                </div>
                            </div>

                            <div class="small text-muted" v-if="item.id_estoque_local">
                                Ao selecionar um local de entrada, o saldo do item será gerado nele ao registrar uma compra. 
                                Caso contrário, será registrado no local informado na nota fiscal.
                            </div>

                            <!-- Campos Customizados -->

                            <div v-if="item.campos_customizados && item.campos_customizados.js_campos.length" class="row mt-3">
                                <div class="col col-12">
                                    <az-sub-title :title="item.campos_customizados.st_titulo" />
                                    <formulario 
                                        :gutters="true" 
                                        v-model="item.campos_customizados.js_campos" 
                                        :saved="true" 
                                        mode="fixed"
                                        :validate="validate"
                                        :config="true" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer" v-if="item && !item.carregando">
                        <az-audit-log-button model="estoqueItem" :id="item.id_estoque_item" v-if="item && item.id_estoque_item" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_estoque_item ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edição de Vias de Acesso -->
        <div class="modal fade" id="edicaoViasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Vias de Acesso</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_comp_vias && edicao_comp_vias.lista_vias">
                        <az-input
                            v-for="(via, ivx) in edicao_comp_vias.lista_vias" :key="ivx"
                            sizing="sm"
                            type="checkbox-group"
                            :label="via.search"
                            v-model="via.selec" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="selecionar_vias()">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>

        <parms-item ref="parms" />
        <estoque-etiqueta ref="estoque_etiqueta" />
        <vincular-cobranca-estoque-item ref="vincular_cobranca" />
        <estoque-item-limite ref="limite" />
        <unidade-operacao-lista ref="unidadeoperacaolista" @refresh="atualizar_componente" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import Multiselect from 'vue-multiselect';
import Importacao from '../../cadastros/shared/Importacao.vue';
import ParmsItem from './ParmsItem.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Formulario from '../consultorio/Formulario.vue';
import AzSingleImageLoader from '../../util/AzSingleImageLoader.vue'
import SelecaoMaterial from './SelecaoMaterial.vue';
import VincularCobrancaEstoqueItem from './VincularCobrancaEstoqueItem.vue';
import EstoqueItemLimite from './EstoqueItemLimite.vue';
import UnidadeOperacaoLista from '../../shared/UnidadeOperacaoLista.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            anos: [],
            unidade: "", 
            options_classes: [],
            novaCobranca: "", 
            id_estoque_grupo: "", 
            copiando: false,
            comp_unidades: null, 
            vias: [], 
            edicao_comp_vias: null,
        }
    },

    props: ['cadastro'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        Multiselect,
        Importacao,
        ParmsItem,
        AzAuditLogButton,
        EstoqueEtiqueta,
        AzSubTitle,
        Formulario,
        AzSingleImageLoader, 
        SelecaoMaterial, 
        VincularCobrancaEstoqueItem, 
        EstoqueItemLimite, 
        UnidadeOperacaoLista, 
    },

    computed: { 
        lista_componentes: function () { 
            if ( !this.item || !this.item.componentes )
                return [];

            return this.item.componentes.filter(item => !item.excluido);
        },  

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.id_estoque_grupo || item.id_estoque_grupo == this.id_estoque_grupo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        }
    },

    methods: { 
        selecionar_vias () { 
            if ( this.edicao_comp_vias && this.edicao_comp_vias.comp ) { 
                this.edicao_comp_vias.comp.js_vias = this.edicao_comp_vias.lista_vias
                    .filter(item => item.selec)
                    .map(item => item.id_prescricao_via);
            }

            $('#edicaoViasModal').modal('hide');
        },

        editar_vias (comp) { 
            this.edicao_comp_vias = { 
                comp: comp,
                lista_vias: _.cloneDeep(this.vias.map(item => { 
                        return { 
                            ...item, 
                            selec: ( comp.js_vias && comp.js_vias.includes(item.id_prescricao_via) ) ? true : false,
                        }
                    }))
            };

            $('#edicaoViasModal').modal('show');
        },

        incluir_convert (item) { 
            if ( !item.converts ) { 
                this.$set(item, 'converts', []);
            }

            item.converts.push({ 
                id_apresentacao: "", 
                st_acao: "D", 
                dc_fator: 10, 
                apresentacao: null, 
                excluido: false, 
            });
        },

        unidade_operacao_lista (comp) { 
            this.comp_unidades = comp;
            this.$refs.unidadeoperacaolista.abrir('estoqueItemComponente', comp.id_estoque_item_componente);
        },

        atualizar_componente(item) { 
            if ( item ) { 
                this.comp_unidades.unidade_operacao_lista_count = item.length;
            }
        },

        limite_de_estoque (item) { 
            this.$refs.limite.abrir(item, item.id_estoque_item, null);
        },

        vincular_cobranca () { 
            this.$refs.vincular_cobranca.abrir();
        },

        incluir_apresentacao (material) { 

            if ( !this.item.apresentacoes ) { 
                this.item.apresentacoes = [];
            }

            this.item.apresentacoes.push({ 
                ampola: material, 
                id_estoque_item: this.item.id_estoque_item, 
                id_estoque_item_ampola: material.id_estoque_item, 
                in_quantidade: null,
                excluido: false, 
            });

        },

        incluir_substituto (material) { 

            this.item.subs.push({ 
                por: material, 
                id_estoque_item: this.item.id_estoque_item, 
                id_estoque_item_por: material.id_estoque_item, 
                excluido: false, 
            });

        },

        incluir_componente (material) {

            if ( this.copiando ) { 

                this.copiando = false;

                this.$util.loadItem(this, { 
                    service: "estoque_items",
                    id: material.id_estoque_item, 
                    parms: { 
                        componentes: true, 
                    }
                })
                .then(res => { 
                    if ( res.componentes && res.componentes.length ) { 
                        res.componentes.forEach(element => {
                            this.incluir_componente({ 
                                ...element.item, 
                                in_quantidade: element.in_quantidade, 
                                in_para_cada: element.in_para_cada, 
                                js_vias: element.js_vias,
                            });                            
                        });
                    }
                });

                return;

            }

            this.item.componentes.push({ 
                item: material, 
                id_estoque_item_pai: this.item.id_estoque_item, 
                id_estoque_item: material.id_estoque_item, 
                in_quantidade: material.in_quantidade ? material.in_quantidade : 1,
                in_para_cada: material.in_para_cada ? material.in_para_cada : 1, 
                excluido: false, 
                js_vias: [], 
            });
        },

        isPowerOfTen(number) { 
            return ( number >= 10 && ( Math.log10(number) % 1 === 0 ) ) ? true : false;
        },

        add_codigo_barra() { 
            this.item.st_codigo_barra.push("");
        },

        remover_codigo_barra(index) { 
            this.item.st_codigo_barra.splice(index, 1);
        },

        emitir_etiqueta(item) {
            const etiquetaItens = [
                 {
                    checked: true,
                    id_estoque_item: item.id_estoque_item,
                    lote: null,
                    validade: null,
                    qtde: 1,
                    search: item.search,
                }
            ];

            this.$refs.estoque_etiqueta.show(etiquetaItens);
        },

        removerCobranca () { 
            this.item.cobranca = null;
            this.item.id_material = null;
            this.item.id_medicamento = null;

            this.$forceUpdate();
        },

        definirCobranca () { 
            if ( !this.novaCobranca ) 
                return;

            this.item.cobranca = _.cloneDeep(this.novaCobranca);
            this.item.id_material = this.novaCobranca.id_material;
            this.item.id_medicamento = this.novaCobranca.id_medicamento;

            this.novaCobranca = "";

            this.$nextTick(() => { 
                this.novaCobranca = null;
            });
        },

        ver_parms(item) { 
            this.$refs.parms.abrir(item);
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },
        incluir () { 
            this.validate = false;
            this.copiando = false;

            let item = {
                id_estoque_item: null, 
                st_estoque_item: "",
                st_unidade_estoque: "",
                st_unidade_compra: "",
                in_fator_conversao: 1,
                st_observacao: "",  
                fl_ativo: true,
                fl_kit: false, 
                js_classes: null, 
                fl_controla_lote: false, 
                fl_fracionado: false, 
                componentes: [], 
                apresentacoes: [], 
                subs: [], 
            };

            this.validate = false;
            this.item = _.cloneDeep (item);
            $('#edicaoModal').modal('show');
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'estoque_items.index',
                    id: 'lista',
                    parms: { 
                        cadastro: true, 
                    }
                },
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        editar (item) { 
            this.validate = false;
            this.copiando = false;
            this.item = null;

            this.$nextTick(() => { 
                let edit_item = _.cloneDeep(item);
                edit_item.carregando = true;

                this.item = edit_item;
                $('#edicaoModal').modal('show');

                this.$util.load(this, { 
                    service: 'estoque_items',
                    func: 'show', 
                    parms: { 
                        id: this.item.id_estoque_item, 
                        cadastro: true, 
                    },
                    loadTo: res => { 
                        this.item = res;
                    }
                });
            });
        },
        atualizar () { 

            this.validate = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length ) { 
                   
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else { 

                    this.$store.commit('loading', true);

                    let query = { q: [ 
                        { 
                            name: 'estoque_items.store',
                            id: 'atualizar',
                            parms: { 
                                ...this.item,
                            }
                        }
                    ]};
                    
                    this.axios.post('/aql', query)
                        .then (res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                $('#edicaoModal').modal('hide');
                                this.load();

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });

                                this.$util.resync(this, 'estoque_items.index');
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

                }

            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'estoque_items.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 

        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Item de Estoque", path: "/suprimentos/item" }
        ]);

        this.$util.loadItem(this, { 
            service: 'estoque_items',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        this.$util.loadItem(this, { 
            service: 'prescricao_vias',
            func: 'index',
        })
        .then(res => { 
            this.vias = res;
        });

        this.load ();
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>